module.exports = __webpack_public_path__ + "img/image8.2ccab38d.jpg";